module.exports = __webpack_public_path__ + "img/0910_2.2141539c.jpg";